import {CreatePhoneApiDto, PhoneApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";

export default class Phone {

	constructor(public readonly internationalPhoneNumber: string,
		public readonly nationalPhoneNumber: string,
		public readonly type: Option<string>,
		public readonly valid: Option<boolean>) {
	}

	copy({
		internationalPhoneNumber = this.internationalPhoneNumber,
		nationalPhoneNumber = this.nationalPhoneNumber,
		type = this.type,
		valid = this.valid
	}) {
		return new Phone(internationalPhoneNumber, nationalPhoneNumber, type, valid);
	}

	public static fromJson(json: PhoneApiDto): Phone {
		return new Phone(json.internationalPhoneNumber, json.nationalPhoneNumber, option(json.type), option(json.valid));
	}

	toJson(): CreatePhoneApiDto {
		const json: CreatePhoneApiDto = {
			internationalPhoneNumber: this.internationalPhoneNumber,
			nationalPhoneNumber: this.nationalPhoneNumber,
			type: this.type.orNull
		};
		return json;
	}

	/**
	 * Check if phone number is mobile type.
	 * @returns {boolean}
	 */
	isMobile() {
		return PhoneTypeEnum.Mobile == this.type.orNull;
	}
}

export enum PhoneTypeEnum {
	Mobile = "MOBILE",
	Landline = "LANDLINE",
	Unknown = "UNKNOWN"
}